import React, { useState } from 'react';
import '../../../../component/modal/modal.css';
import { PrimaryButton, SecondaryButton } from '../../../../component/buttonComponent/ButtonComponent';
import OdSelect from './OdSelect';

/**
 * Which asset's trips to export.
 *
 * The report holds up to ten assets and the export is one file, so the scope has to be asked for
 * rather than inferred — a reader who generated a ten-asset report and wanted one asset's trips
 * had no way to say so, and the alternative reading (export everything, filter in the spreadsheet)
 * is the manual step this export exists to remove.
 *
 * `''` is the fleet console's `__ALL`: every asset in one file, and the default, so the reader who
 * wants the whole report presses Export twice and is done.
 */
const OdExportDialog = (props) => {
    const {
        trips, assets, onCancel, onExport,
    } = props;

    const [asset, setAsset] = useState('');

    // Counted here rather than passed in, so it answers for the asset in the picker rather than
    // for the report: a static total sat unchanged above a changing selection and read as though
    // the choice had not taken. `trips` is already filtered, so this is the file's real row count.
    const count = asset
        ? trips.filter((trip) => trip.assetName === asset).length
        : trips.length;

    return (
        <div className="modal-container-table-bg">
            <div className="modal-container-logout">
                <div className="od-export-header">
                    <span className="od-export-title">Export trips</span>
                    <span className="od-export-subtitle">Choose which asset to export.</span>
                </div>

                <div className="od-export-body">
                    <OdSelect
                      label="Asset"
                      value={asset}
                      onChange={setAsset}
                      ariaLabel="Asset to export"
                      options={[
                          { value: '', label: 'All assets' },
                          ...assets.map((name) => ({ value: name, label: name })),
                      ]}
                    />
                    <span className="od-export-count">
                        {count === 0
                            ? 'No trips to export — the current filters leave this asset with none.'
                            : `${count} trip${count === 1 ? '' : 's'} will be exported.`}
                    </span>
                </div>

                {/* Not modal-actions-content: those buttons carry `flex: none` and take their
                    width from a `width` prop, so two of them side by side each asked for the full
                    card and overflowed it. Here the row divides itself between them instead. */}
                <div className="od-export-actions">
                    <SecondaryButton label="Cancel" onClickFunction={onCancel} />
                    <PrimaryButton label="Export CSV" onClickFunction={() => onExport(asset)} disable={count === 0} />
                </div>
            </div>
        </div>
    );
};

export default OdExportDialog;
